import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ProgramsPage = lazy(() => import('../pages/programs/page'));
const ImpactPage = lazy(() => import('../pages/impact/page'));
const DonatePage = lazy(() => import('../pages/donate/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const PartnershipsPage = lazy(() => import('../pages/partnerships/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const FuwaAleshPage = lazy(() => import('../pages/fuwaalesh/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/programs',
    element: <ProgramsPage />,
  },
  {
    path: '/impact',
    element: <ImpactPage />,
  },
  {
    path: '/donate',
    element: <DonatePage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/partnerships',
    element: <PartnershipsPage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/fuwaalesh',
    element: <FuwaAleshPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
